"use client";

import { useCallback, useSyncExternalStore } from "react";

// Matches the `lg:` breakpoint used across the templates.
const MOBILE_QUERY = "(max-width: 1023px)";

const subscribe = (onChange) => {
	if (typeof window === "undefined") return () => {};
	const mql = window.matchMedia(MOBILE_QUERY);
	mql.addEventListener("change", onChange);
	return () => mql.removeEventListener("change", onChange);
};

const getSnapshot = () => window.matchMedia(MOBILE_QUERY).matches;

// The server has no viewport, so it renders the desktop branch and React
// re-renders once after hydration. Reading `isMobile` from react-device-detect
// during render instead produced a hydration mismatch, because the server said
// desktop and the very first client render already said mobile.
const getServerSnapshot = () => false;

export default function useIsMobile() {
	return useSyncExternalStore(
		useCallback(subscribe, []),
		getSnapshot,
		getServerSnapshot
	);
}
